module.exports = __webpack_public_path__ + "73ace476a8f341a17644d93be212d14e.fbx";